export default class GtmEventActions {
    static get OPEN(): string {
        return 'open'
    }

    static get CLOSE(): string {
        return 'close'
    }

    static get DELETE(): string {
        return 'delete'
    }

    static get REPLACE(): string {
        return 'replace'
    }

    static get CLICK(): string {
        return 'click'
    }

    static get SELECT(): string {
        return 'select'
    }

    static get CANCEL(): string {
        return 'cancel'
    }

    static get CONFIRM(): string {
        return 'confirm'
    }
}
